export default {
      id: "oc-res-ai-virtual-key-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-ai-virtual-key",
      toString: function () {
        return this.url;
      }
    }